export default {
    name: "pageLost",
    mounted() {
        document.querySelector('body').classList.add('bg-fff');
        this.$once('hook:beforeDestroy', () => {
            document.querySelector('body').classList.remove('bg-fff');
        });
    }
};